import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalDomain from "./ModalDomain";

const useModalDomain = (onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, mode: 'none', domain_id: null })  ;

    const onClickActivate = ( domain_id, mode) =>
    {
        setDialog ({ openState: true, domain_id: domain_id, mode: mode});
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, domain_id: null, mode: 'none'});
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, domain_id: null, mode: 'none'});

        // Tell the parent we're done
        onSaveCompleted( result ) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal key='domainModal' center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalDomain key='mo' domain_id={dialog.domain_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalDomain ;
